import rounds from './rounds'

// authorization endpoints
//export const CALLBACK_URL = process.env.CALLBACK_URL || 'http://localhost:3000';
//export const API_BASE_URL = process.env.API_BASE_URL || 'https://34.193.121.143:9201/rest';
//export const AUTHORIZATION_URL = process.env.AUTHORIZATION_URL || 'http://34.193.121.143:9100/index.cfm/event/oauth';
//export const CRED_SERVER_URL = process.env.CRED_SERVER_URL || 'http://localhost:3001';

// works locally
//export const CALLBACK_URL = 'http://192.168.99.100:3000';
//export const API_BASE_URL = 'https://34.193.121.143:9201/rest';
//export const AUTHORIZATION_URL = 'https://34.193.121.143:9101/index.cfm/event/oauth';
//export const CRED_SERVER_URL = 'http://192.168.99.100:3001';

export const CALLBACK_URL =
	process.env.REACT_APP_CALLBACK_URL ||
	'http://localhost:3000/oauthRedirect'
export const API_BASE_URL =
	process.env.REACT_APP_API_BASE_URL || 'https://api.motorsportreg.com/rest'
export const AUTHORIZATION_URL =
	process.env.REACT_APP_AUTHORIZATION_URL ||
	'https://www.motorsportreg.com/index.cfm/event/oauth'

export const REQUEST_TOKEN_URL = `${API_BASE_URL}/tokens/request`
export const ACCESS_TOKEN_URL = `${API_BASE_URL}/tokens/access`

// api endpoints
export const USER_INFO_URL = `${API_BASE_URL}/me.json`
export const GET_CREDENTIALS_URL = `${API_BASE_URL}/motoamerica/credentials.json`
export const REQUEST_CREDENTIAL = `${API_BASE_URL}/motoamerica/credentials.json`
export const CANCEL_CREDENTIAL = `${API_BASE_URL}/motoamerica/credentials`
export const UPDATE_CREDENTIAL = `${API_BASE_URL}/motoamerica/credentials`

// others
export const ROUNDS = rounds;
export const CREDENTIAL_TYPES = ['season', 'season_paddock', 'season_media', 'guest', 'paddock_guest_wristband', 'vendor_guest_wristband', 'broadcast_guest_wristband', 'model', 'media_single', 'working_single', 'hotpit_guest'];
export const COTA_DISCLAIMER = "Premier Superbike is limited to 3 guest passes, all others riders limited to 2 guest passes."
export const CREDENTIAL_TYPE_LABELS = {
	"season": {
		type_label: "season",
		type_link: "season",
		filter_label: "Season",
		event_details_key: "seasonCredentials",
		singular: "Season Credential",
		plural: "Season Credentials"
	},
	"season_paddock": {
		type_label: "season",
		type_link: "season-paddock",
		filter_label: "Season Paddock",
		event_details_key: "season_paddockCredentials",
		singular: "Season Paddock Credential",
		plural: "Season Paddock Credentials"
	},
	"season_media": {
		type_label: "season",
		type_link: "season-media",
		filter_label: "Season Media",
		event_details_key: "season_media_credentials",
		singular: "Season Media Credential",
		plural: "Season Media Credentials"
	},
	"guest": {
		type_label: "guest",
		type_link: "vip-guest",
		filter_label: "Paddock",
		event_details_key: "vipGuestCredentials",
		singular: "Paddock Credential",
		plural: "Paddock Credentials"
	},
	"paddock_guest_wristband": {
		type_label: "guest",
		type_link: "paddock-guest-wristband",
		filter_label: "Paddock Wristband",
		event_details_key: "paddockGuestWristbandCredentials",
		singular: "Paddock Wristband",
		plural: "Paddock Wristbands"
	},
	"vendor_guest_wristband": {
		type_label: "guest",
		type_link: "vendor-guest-wristband",
		filter_label: "Vendor Wristband",
		event_details_key: "vendorGuestWristbandCredentials",
		singular: "Vendor Wristband",
		plural: "Vendor Wristbands"
	},
	"broadcast_guest_wristband": {
		type_label: "guest",
		type_link: "broadcast-guest-wristband",
		filter_label: "Broadcast Wristband",
		event_details_key: "broadcastGuestWristbandCredentials",
		singular: "Broadcast Wristband",
		plural: "Broadcast Wristbands"
	},
	"model": {
		type_label: "model",
		type_link: "model",
		filter_label: "Model",
		event_details_key: "modelCredentials",
		singular: "Model Wristband",
		plural: "Model Wristbands"
	},
	"hotpit_guest": {
		type_label: "guest",
		type_link: "hotpit-guest",
		filter_label: "Hotpit Guest",
		event_details_key: "vipSingleCredentials",
		singular: "Hotpit Guest Credential",
		plural: "Hotpit Guest Credentials"
	},
	"working_single": {
		type_label: "single",
		type_link: "working-single",
		filter_label: "Working Single",
		event_details_key: "workingSingleCredentials",
		singular: "Working Single Event Wristband",
		plural: "Working Single Event Wristband"
	},
	"media_single": {
		type_label: "single",
		type_link: "media-single",
		filter_label: "Media Single",
		event_details_key: "mediaSingleCredentials",
		singular: "Media Single Event Wristband",
		plural: "Media Single Event Wristband"
	}
};



// WEBPACK FOOTER //
// ./src/constants/index.js